import React, { useMemo } from 'react';
import { Box, costFormater, GagueChart, SelectDropdown, SpendPeriodType, Text } from '@common-fe/common-fe';

import { useSpendPeriodTracker } from './hooks';
import { PeriodText } from './SpendPeriodTracker.types';

interface Props {
  accountId?: string;
  spendPeriodType?: SpendPeriodType;
}

const SpendPeriodTracker: React.FC<Props> = ({ accountId, spendPeriodType }) => {
  const { gagueChartValue, periodRemaining, periodLoading, options, selectedPeriod, handleSelectePeriod } =
    useSpendPeriodTracker({ accountId });

  const periodText = useMemo(() => {
    if (spendPeriodType === SpendPeriodType.PLAN_YEAR) {
      return PeriodText.PLAN_YEAR;
    }
    if (spendPeriodType === SpendPeriodType.MONTHLY) {
      return PeriodText.MONTHLY;
    }
    return PeriodText.DEFAULT;
  }, [spendPeriodType]);

  return (
    <Box
      pad="spacing24"
      border={{ color: 'border2' }}
      round="s"
      background={{ color: 'canvas' }}
      height={{ min: '248px', height: 'fit-content' }}
      width="100%"
      data-testid="spend-period-tracker_wrapper"
    >
      <Box direction="row" align="center" justify="between" margin={{ bottom: 's' }} data-testid="">
        <Text size="16px" color="title" weight={700}>
          Spend Limit Tracker
        </Text>
        <Box width="230px" margin={{ left: 'spacing8' }}>
          <SelectDropdown
            id="periodTracker"
            testId="spend-limit-period"
            name="periodTracker"
            isLoading={periodLoading}
            singleMode
            activeTitle
            prefix="Spend period"
            options={options}
            value={selectedPeriod}
            onChange={handleSelectePeriod}
          />
        </Box>
      </Box>
      <Box direction="row" justify="center">
        <Box width="296px">
          <GagueChart items={gagueChartValue} styles={{ padding: 0 }} thinMode>
            <Box direction="column" align="center" justify="end" margin={{ top: 'auto' }}>
              <Text weight={400} color="textSecondary">
                Remaining
              </Text>
              <Text size="2xl" weight={700} color="textBody">
                {costFormater(periodRemaining?.remaining || 0, { isPrecision: true })}
              </Text>
              <Text color="textBody">
                of {costFormater(periodRemaining?.spendLimit || 0, { isPrecision: true })}
              </Text>
              <Text color="textBody">{periodText}</Text>
            </Box>
          </GagueChart>
        </Box>
      </Box>
    </Box>
  );
};

export default React.memo(SpendPeriodTracker);
